<template>
	<div id="switch-trip">
		<div class="buisness-travel df-jsb-aic" :class="{ 'mt2': !isPhone }">
			<h3 class="raleway-semi-p13 mb-0">Voyage d'affaires <span v-if="getFilterCount('business')" class="filter-count">({{ getFilterCount('business') }})</span></h3>
			<input class="m-0" type="checkbox" id="voyage d'affaires" v-model="selected" /><label class="m-0" for="voyage d'affaires">Voyage d'affaires</label>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'switch-trip',
		props: ['filterCounts'],
		data() {
			return {
				selected: false,
			};
		},
		methods: {
			getFilterCount(filterType) {
				if (!this.filterCounts || !this.filterCounts.collection_names) return 0;
				// Find the count for 'Léonie' collection (business travel)
				const businessData = this.filterCounts.collection_names.find(item => item.key === 'Léonie');
				return businessData ? businessData.count : 0;
			},
		},
		watch: {
			selected(val) {
				this.$emit('checked', val, 'business');
			},
		},
    computed: {
      isPhone() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
          return true;
        } else {
          return false;
        }
      },
    }
	};
</script>

<style lang="scss" scope="app/assets/stylesheets/components/lodging-filter">
.filter-count {
  color: #666;
  font-size: 0.9em;
  font-weight: normal;
  margin-left: 4px;
}
</style>
